<template>
  <div>
    <Select
      v-model="locale"
      @update:model-value="updateLocale"
      :options="$i18n.availableLocales"
      style="min-width: 5rem"
      class="w-full"
    />
  </div>
</template>

<script lang="ts">
import { useUiStore } from '@/stores/UiStore.ts';

export default {
  name: 'LanguagePicker',
  data() {
    return {
      locale: 'en',
    };
  },
  mounted() {
    this.locale = useUiStore().locale;
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      useUiStore().setLocale(locale);
    },
  },
};
</script>
